import { addParamsToUrl } from '@zapier/url-utils';
import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildUpgradeUrl = (
  currentPlanName: string,
  upgradeToPlanName: string,
  interval: Interval,
  selectedCurrency?: string
) => {
  const currentPlanNameString = currentPlanName.toLowerCase();
  const upgradeToPlanNameString = upgradeToPlanName.toLowerCase();

  const url =
    currentPlanName && upgradeToPlanName
      ? encodeURI(
          `/app/billing/plans/upgrade/${currentPlanNameString}/${upgradeToPlanNameString}?interval=${interval}`
        )
      : '';
  return addParamsToUrl(url, { currency: selectedCurrency }, true);
};
